export default __webpack_public_path__ + "static/media/sakura.fdfdd0d9.png";